import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { StandardProductDetails } from '@idealsupply/products-api-angular-client';
import { ProductUnitLabels } from 'products-data';
import { ItemResultsComponent } from '../../../../../item';
import { RenderInProductDetailsViewDirective } from '../../../../layouts/product-detail/product-detail-layout/render-targets/render-in-product-details.directive';
import { ProductDetailLayoutComponentsProviderComponentBase } from '../../../../layouts/product-detail/ProductDetailLayoutComponentsProviderComponentBase';

@Component({
  selector: 'ideal-standard-product-detail-components',
  imports: [RenderInProductDetailsViewDirective, ItemResultsComponent],
  standalone: true,
  templateUrl: './standard-product-detail-layout-components-provider.component.html',
  styleUrl: './standard-product-detail-layout-components-provider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StandardProductDetailLayoutComponentsProviderComponent extends ProductDetailLayoutComponentsProviderComponentBase {
  protected readonly productDetails = computed(() => this.productStore.productDetails() as StandardProductDetails | undefined);

  protected readonly specSheetUrl = computed(() => this.productDetails()?.specSheetUrl ?? '');
  protected readonly unitLabel = computed(() => {
    const u = this.productDetails()?.unit ?? '';
    return ProductUnitLabels[u as keyof typeof ProductUnitLabels] ?? { other: u };
  });
  protected readonly boxQuantity = computed(() => this.productDetails()?.boxQuantity ?? 0);
  protected readonly longDescription = computed(() => this.productDetails()?.longDescription ?? '');
}
